angular.module('core').filter('percent', [ 'numberFilter',
	function($numberFilter) {
		return function(input, fractionSize) {

			var decimalPlaces = fractionSize || 0;

			if(_.isUndefined(input) || !_.isNumber(input)) {
				return '0%';
			}
			else {
				return $numberFilter(input, decimalPlaces) + '%';
			}
		};
	}
]);
